import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loading-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    id: "loading-screen",
    style: _normalizeStyle({background: _ctx.loadingProps.fullScreen? 'white' : 'rgb(0 0 0 / 0.6)'})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_font_awesome_icon, {
        icon: _ctx.loadingProps.icon
      }, null, 8, ["icon"]),
      _createElementVNode("span", null, _toDisplayString(_ctx.loadingProps.message), 1)
    ])
  ], 4))
}